import createStore from "@Stores/base-factories"
import hookSiteSelectedFactory from "@Stores/base-factories/store-site-selection"

const { Provider, useStore } = createStore()
  .extend(hookSiteSelectedFactory('site_id'))
  .extendHookCollectionFactory('admin/token')
  .extendHookCollectionsFactory('admin/tokens')
  .factory()

export {
  Provider as TokenProvider,
  useStore as useTokenStore,
}
